import ConfigParameter, {gettext} from "../ConfigParameter";

export default class PinSection extends ConfigParameter {

    constructor() {
        let defaultOption = 0;
        let options = [
            {value: "", label: gettext("Don't pin")},
            {value: "top", label: gettext("Top")},
            {value: "middle", label: gettext("Middle")},
            {value: "bottom", label: gettext("Bottom")},
        ];

        super('pinSection', 'object-select', gettext('Pin Section'), 'position', options[defaultOption].value, null, options);
    }

}


// WEBPACK FOOTER //
// ./src/cmsCore/Creator/ConfigParameters/ConfigParameters/PinSection.js